import { csx } from '@vtex/admin-ui'

export const uploadAreaWrapper = csx({
  width: '100%',
  position: 'static',
  height: '240px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#F4F4F4',
  borderRadius: '$base',
  'button:hover, button': {
    display: 'flex',
    bg: 'transparent !important',
  },
  '>div': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  '&.invalid-format': {
    border: 'none',
  },
  '&.empty-upload': {
    border: '$form.neutral',
    borderStyle: 'dashed',
    backgroundColor: '#F4F4F4',
    cursor: 'pointer',
  },
})

export const uploadedFile = csx({
  border: '$form.neutral',
  borderRadius: '$base',
  backgroundColor: '#fff',
  width: '90% !important',
  height: '60px',
  display: 'flex',
  alignItems: 'center',
  padding: '0 16px',
  justifyContent: 'space-between',
  cursor: 'pointer',

  '>div': {
    display: 'flex',
    alignItems: 'center',
    width: 'auto !important',
  },
})

export const iconWrapper = csx({
  backgroundColor: '#F0F0F0',
  width: '32px !important',
  height: '32px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '$base',
  marginRight: '12px',
})

export const iconInvalid = csx({
  backgroundColor: '#F8E3E3 !important',
  color: '#CC3D3D',
})
